import React from 'react';
import type {TagValue} from '@netx/core-asset/models/attribute';
import {AttributeVocabularyLookup} from '@netx/core-attribute-vocabulary/components/AttributeVocabularyLookup';
import {
	type IPerson,
	PersonAutoList,
} from '@netx/core-person/components/PersonAutoList';
import {i18n} from '@netx/core/i18n';
import {usePlaceholder} from '../../../../hooks';
import type {CommonProps} from '../../types';

export interface TagAttributeProps extends CommonProps<TagValue> {}

export const TagAttributePrimitive = ({
	action,
	attrData,
	disableFolksonomy,
	hideLabel,
	isMetadataTarget,
	multipleValues,
	placeholder = '',
	readOnly,
	value,
	// so it does no get passed along
	// only some of our attribute types are offer lookup
	isMetadataLookup,
	onLookup,
	...props
}: TagAttributeProps) => {
	const cleared = action === 'clear';
	const defaultValue = value == null || !Array.isArray(value) ? [] : value;
	const flexible = !disableFolksonomy && attrData.spec2 === 1;

	const textfieldPlaceholder = usePlaceholder(
		attrData,
		placeholder !== '' ? placeholder : i18n.t('i18n.typeToAddTags'),
		{
			cleared,
			disable: props.loadingValue,
			multipleValues,
			readOnly,
			value: defaultValue,
		},
	);

	if (attrData.attributeid === -122) {
		return (
			<PersonAutoList
				{...props}
				label={i18n.t('i18n.person')}
				value={value as any}
			/>
		);
	}

	return (
		<AttributeVocabularyLookup<true>
			hideErrorMessage
			flexible={flexible}
			id={attrData.attributeid.toString()}
			label={hideLabel ? undefined : attrData.name}
			name={attrData.name}
			{...props}
			placeholder={textfieldPlaceholder}
			value={defaultValue}
			vocabularyId={attrData.spec1}
			InputProps={{
				InputLabelProps: {
					shrink: multipleValues || cleared ? true : undefined,
				},
			}}
		/>
	);
};

export const TagAttribute = React.memo(TagAttributePrimitive);

export default TagAttribute;
